module.exports = __webpack_public_path__ + "public/Icons/fb.png?68b18ab3";